import React from 'react';

export default function Gauge({ value, size = "small", showValue = false }) {
  // Value should be 0-100
  const validValue = Math.min(Math.max(value, 0), 100);
  
  // Dimensions based on Geist UI sizes
  const sizeMap = {
    small: 32,
    medium: 64,
    large: 120
  };
  const width = sizeMap[size] || 32;
  const strokeWidth = width / 8; // Vercel style is usually thicker relative to size
  const radius = (width - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (validValue / 100) * circumference;

  // Color determination based on score - Vercel Style
  let color;
  
  // Vercel / Geist UI color scale approximation
  if (value === 0) {
    color = 'var(--text-tertiary)'; // Gray for 0
  } else if (value < 33) {
    color = '#e00'; // Red for low scores (0-33)
  } else if (value < 66) {
    color = '#f5a623'; // Orange/Amber for medium scores (33-66)
  } else {
    color = 'var(--success-color)'; // Green/Teal for high scores (66-100)
    // You can also use #0070f3 (Vercel Blue) or #7928ca (Vercel Purple) if preferred
  }

  return (
    <div style={{ position: 'relative', width, height: width, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg width={width} height={width} style={{ transform: 'rotate(-90deg)' }}>
        {/* Background Circle */}
        <circle
          cx={width / 2}
          cy={width / 2}
          r={radius}
          stroke="var(--background-medium)" // Lighter background track
          strokeWidth={strokeWidth}
          fill="none"
        />
        {/* Progress Circle */}
        <circle
          cx={width / 2}
          cy={width / 2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.5s ease' }}
        />
      </svg>
      {showValue && (
        <span style={{ 
          position: 'absolute', 
          fontSize: width * 0.25, 
          fontWeight: 'bold',
          color: 'var(--text-primary)'
        }}>
          {Math.round(validValue)}
        </span>
      )}
    </div>
  );
}
